import React, { useState, useContext } from "react";
import styled from "styled-components";
import useAddress from "../hooks/useAddress";
import { AuthContext } from "../hooks/useLogin";

const NewAddress = ({ onClose }) => {
  const { addAddress, loading, error: apiError } = useAddress();
  const { user } = useContext(AuthContext);
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [barangays, setBarangays] = useState([]);
  const [selectedBarangay, setSelectedBarangay] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [homeAddress, setHomeAddress] = useState("");
  const [error, setError] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const boholData = [
    { municipality: "Alburquerque", barangays:  ["Bahi", "Basacdacu", "Cantiguib", "Dangay", "East Poblacion", "Ponong", "San Agustin","Santa Filomena","Tagbuane", "Toril","West Poblacion" ] },
    { municipality: "Alicia", barangays: ["Cabatang", "Cagongcagong", "Cambaol", "Cayacay", "Del Monte", "Katipunan", "La Hacienda","Mahayag","Napo","Pagahat","Poblacion (Calingganay)","Progreso","Putlongcam","Sudlon (Omhor)", "Untaga" ] },
    { municipality: "Anda", barangays: ["Almaria", "Bacong", "Badiang", "Buenasuerte", 
      "Candabong", "Casica", "Katipunan", "Linawan", "Lundag", "Poblacion", "Santa Cruz", "Suba","Talisay", "Tanod", "Tawid", "Virgen"] },  
    { municipality: "Antequera", barangays:  ["Angilan", "Bantolinao", "Bicahan", "Bitaugan","Bungahan", "Canlaas", "Can-omay", "Cansibuan", "Celing", "Danao", "Danicop", "Mag-aso","Poblacion", "Quinapon-an", "Santo Rosario", "Tabuan", "Tagubaas", "Tupas", "Ubojan", "Viga", "Villa Aurora (Canoc-oc)"] },
    { municipality: "Baclayon", barangays:  ["Buenaventura", "Cambanac", "Dasitam", "Guiwanon","Landican", "Laya", "Libertad", "Montana", "Pamilacan", "Payahan", "Poblacion", "San Isidro", "San Roque", "San Vicente", "Santa Cruz", "Taguihon", "Tanday"] },
    { municipality: "Balilihan", barangays: ["Baucan Norte", "Baucan Sur", "Boctol", "Boyog Norte","Boyog Proper", "Boyog Sur", "Cabad", "Candasig", "Cantalid", "Cantomimbo", "Cogon", "Datag Norte","Datag Sur", "Del Carmen Este (Pob.)", "Del Carmen Norte (Pob.)","Del Carmen Sur (Pob.)", "Del Carmen Weste (Pob.)", "Del Rosario","Dorol", "Haguilanan Grande", "Hanopol Este", "Hanopol Norte","Hanopol Weste", "Magsija", "Maslog", "Sagasa", "Sal-ing","San Isidro", "San Roque", "Santo Niño", "Tagustusan"] },
    { municipality: "Batuan", barangays: ["Aloja", "Behind The Clouds (San Jose)", "Cabacnitan", "Cambacay", "Cantigdas", "Garcia", "Janlud", "Poblacion Norte", "Poblacion Sur", "Poblacion Vieja (Longsudaan)", "Quezon", "Quirino", "Rizal", "Rosariohan", "Santa Cruz"]},   
    { municipality: "Bien Unido", barangays:["Bilangbilangan Dako", "Bilangbilangan Diot", "Hingotanan East", "Hingotanan West", "Liberty", "Malingin", "Mandawa", "Maomawan", "Nueva Esperanza", "Nueva Estrella", "Pinamgo", "Poblacion (Bien Unido)", "Puerto San Pedro", "Sagasa", "Tuboran"]},   
    { municipality: "Bilar", barangays:  ["Bonifacio", "Bugang Norte", "Bugang Sur", "Cabacnitan (Magsaysay)", "Cambigsi", "Campagao", "Cansumbol", "Dagohoy", "Owac", "Poblacion", "Quezon", "Riverside", "Rizal", "Roxas", "Subayon", "Villa Aurora", "Villa Suerte", "Yanaya", "Zamora"]},
    { municipality: "Buenavista", barangays: ["Anonang", "Asinan", "Bago", "Baluarte", "Bantuan", "Bato", "Bonotbonot", "Bugaong", "Cambuhat", "Cambus-oc", "Cangawa", "Cantomugcad", "Cantores", "Cantuba", "Catigbian", "Cawag", "Cruz", "Dait", "Eastern Cabul-an", "Hunan", "Lapacan Norte", "Lapacan Sur", "Lubang", "Lusong (Plateau)", "Magkaya", "Merryland", "Nueva Granada", "Nueva Montana", "Overland", "Panghagban", "Poblacion", "Puting Bato", "Rufo Hill", "Sweetland", "Western Cabul-an"]},
    { municipality: "Calape", barangays: ["Abucayan Norte", "Abucayan Sur", "Banlasan", "Bentig", "Binogawan", "Bonbon", "Cabayugan", "Cabudburan", "Calunasan", "Camias", "Canguha", "Catmonan", "Desamparados (Pob.)", "Kahayag", "Kinabag-an", "Labuon", "Lawis", "Liboron", "Lomboy", "Lo-oc", "Lucob", "Madangog", "Magtongtong", "Mandaug", "Mantatao", "Sampoangon", "San Isidro", "Santa Cruz (Pob.)", "Sojoton", "Talisay", "Tinibgan", "Tultugan", "Ulbujan"] },
    { municipality: "Candijay", barangays: ["Abihilan", "Anoling", "Boyo-an", "Cadapdapan", "Cambane", "Canawa", "Can-olin", "Cogtong", "La Union", "Luan", "Lungsoda-an", "Mahangin", "Pagahat", "Panadtaran", "Panas", "Poblacion", "San Isidro", "Tambongan", "Tawid", "Tubod (Tres Rosas)", "Tugas"]},
    { municipality: "Carmen", barangays: ["Alegria", "Bicao", "Buenavista", "Buenos Aires", "Calatrava", "El Progreso", "El Salvador", "Guadalupe", "Katipunan", "La Libertad", "La Paz", "La Salvacion", "La Victoria", "Matin-ao", "Montehermoso", "Montesuerte", "Montesunting", "Montevideo", "Nueva Fuerza", "Nueva Vida Este", "Nueva Vida Norte", "Nueva Vida Sur", "Poblacion Norte", "Poblacion Sur", "Tambo-an", "Vallehermoso", "Villaflor", "Villafuerte", "Villarcayo"]},
    { municipality: "Catigbian", barangays: ["Alegria", "Ambuan", "Baang", "Bagtic", "Bongbong", "Cambailan", "Candumayao", "Causwagan Norte", "Hagbuaya", "Haguilanan", "Kang-iras", "Libertad Sur", "Liboron", "Mahayag Norte", "Mahayag Sur", "Maitum", "Mantasida", "Poblacion", "Poblacion Weste", "Rizal", "Sinakayanan", "Triple Union"]},
    { municipality: "Clarin", barangays: ["Bacani", "Bogtongbod", "Bonbon", "Bontud", "Buacao", "Buangan", "Cabog", "Caboy", "Caluwasan", "Candajec", "Cantoyoc", "Comaang", "Danahao", "Katipunan", "Lajog", "Mataub", "Nahawan", "Poblacion Centro", "Poblacion Norte", "Poblacion Sur", "Tangaran", "Tontunan", "Tubod", "Villaflor"]},
    { municipality: "Corella", barangays: ["Anislag", "Canangca-an", "Canapnapan", "Cancatac", "Pandol", "Poblacion", "Sambog", "Tanday"]},
    { municipality: "Cortes", barangays: ["De la Paz", "Fatima", "Loreto", "Lourdes", "Malayo Norte", "Malayo Sur", "Monserrat", "New Lourdes", "Patrocinio", "Poblacion", "Rosario", "Salvador", "San Roque", "Upper de la Paz"]},
    { municipality: "Dagohoy", barangays: ["Babag", "Cagawasan", "Cagawitan", "Caluasan", "Candelaria", "Can-oling", "Estaca", "La Esperanza", "Mahayag", "Malitbog", "Poblacion", "San Miguel", "San Vicente", "Santa Cruz", "Villa Aurora"]},
    { municipality: "Danao", barangays: ["Cabatuan", "Cantubod", "Carbon", "Concepcion", "Dagohoy", "Hibale", "Magtangtang", "Nahud", "Poblacion", "Remedios", "San Carlos", "San Miguel", "Santa Fe", "Santo Ni o", "Tabok", "Taming", "Villa Anunciado"]},
    { municipality: "Dauis", barangays: ["Biking", "Bingag", "Catarman", "Dao", "Mariveles", "Mayacabac", "Poblacion", "San Isidro (Canlongon)", "Songculan", "Tabalong", "Tinago", "Totolan"]},
    { municipality: "Dimiao", barangays:["Abihid", "Alemania", "Baguhan", "Bakilid", "Balbalan", "Banban", "Bauhugan", "Bilisan", "Cabagakian", "Cabanbanan", "Cadap-agan", "Cambacol", "Cambayaon", "Canhayupon", "Canlambong", "Casingan", "Catugasan", "Datag", "Guindaguitan", "Guingoyuran", "Ile", "Lapsaon", "Limokon Ilaod", "Limokon Ilaya", "Luyo", "Malijao", "Oac", "Pagsa", "Pangihawan", "Puangyuta", "Sawang", "Tangohay", "Taongon Cabatuan", "Taongon Can-andam", "Tawid Bitaog"]},
    { municipality: "Duero", barangays: ["Alejawan", "Angilan", "Anibongan", "Bangwalog", "Cansuhay", "Danao", "Duay", "Guinsularan", "Imelda", "Itum", "Langkis", "Lobogon", "Madua Norte", "Madua Sur", "Mambool", "Mawi", "Payao", "San Antonio (Pob.)", "San Isidro", "San Pedro", "Taytay"]},
    { municipality: "Garcia Hernandez", barangays:["Abijilan", "Antipolo", "Basiao", "Cagwang", "Calma", "Cambuyo", "Canayaon East", "Canayaon West", "Candanas", "Candulao", "Catmon", "Cayam", "Cupa", "Datag", "Estaca", "Libertad", "Lungsodaan East", "Lungsodaan West", "Malinao", "Manaba", "Pasong", "Poblacion East", "Poblacion West", "Sacaon", "Sampong", "Tabuan", "Togbongon", "Ulbujan East", "Ulbujan West", "Victoria"]},
    { municipality: "Getafe", barangays: ["Banacon", "Campao Occidental", "Campao Oriental", "Jagoliao", "Poblacion"] },
    { municipality: "Guindulman", barangays:  ["Basdio", "Bato", "Bayong", "Biabas", "Bulawan", "Cabantian", "Canhaway", "Cansiwang", "Casbu", "Catungawan Norte", "Catungawan Sur", "Guinacot", "Guio-ang", "Lombog", "Mayuga", "Sawang (Pob.)", "Tabajan (Pob.)", "Tabunok", "Trinidad"]},
    { municipality: "Inabanga", barangays:["Anonang", "Badiang", "Baguhan", "Bahan", "Banahao", "Baogo", "Bugang", "Cagawasan", "Cagayan", "Cambitoon", "Canlinte", "Cawayan", "Cogon", "Cuaming", "Dagnawan", "Dagohoy", "Dait Sur", "Datag", "Fatima", "Hambongan", "Ilaud (Pob.)", "Ilaya", "Ilihan", "Lapacan Norte", "Lapacan Sur", "Lawis", "Liloan Norte", "Liloan Sur", "Lomboy", "Lonoy Cainsican", "Lonoy Roma", "Lutao", "Luyo", "Mabuhay", "Maria Rosario", "Nabuad", "Napo", "Ondol", "Poblacion", "Riverside", "Saa", "San Isidro", "San Jose", "Santo Niño", "Santo Rosario", "Sua", "Tambook", "Tungod", "Ubujan", "U-og"]},
    { municipality: "Jagna", barangays: ["Alejawan", "Balili", "Boctol", "Bunga Ilaya", "Bunga Mar", "Buyog", "Cabunga-an", "Calabacita", "Cambugason", "Can-ipol", "Canjulao", "Cantagay", "Cantuyoc", "Can-uba", "Can-upao", "Faraon", "Ipil", "Kinagbaan", "Laca", "Larapan", "Lonoy", "Looc", "Malbog", "Mayana", "Naatang", "Nausok", "Odiong", "Pagina", "Pangdan", "Poblacion (Pondol)", "Tejero", "Tubod Mar", "Tubod Monte"]},
    { municipality: "Jetafe", barangays: ["Alumar", "Banacon", "Buyog", "Cabasakan", "Campao Occidental", "Campao Oriental", "Cangmundo", "Carlos P. Garcia", "Corte Baud", "Handumon", "Jagoliao", "Jandayan Norte", "Jandayan Sur", "Mahanay (Mahanay Island)", "Nasingin", "Pandanon", "Poblacion", "Saguise", "Salog", "San Jose", "Santo Niño", "Taytay", "Tugas", "Tulang"]},
    { municipality: "Lila", barangays: ["Banban", "Bonkokan Ilaya", "Bonkokan Ubos", "Calvario", "Candulang", "Catugasan", "Cayupo", "Cogon", "Jambawan", "La Fortuna", "Lomanoy", "Macalingan", "Malinao East", "Malinao West", "Nagsulay", "Poblacion", "Taug", "Tiguis"]},
    { municipality: "Loay", barangays: ["Agape", "Alegria Norte", "Alegria Sur", "Bonbon", "Botoc Occidental", "Botoc Oriental", "Calvario", "Concepcion", "Hinawanan", "Las Salinas Norte", "Las Salinas Sur", "Palo", "Poblacion Ibabao", "Poblacion Ubos", "Sagnap", "Tambangan", "Tangcasan Norte", "Tangcasan Sur", "Tayong Occidental", "Tayong Oriental", "Tocdog Dacu", "Tocdog Ilaya", "Villalimpia", "Yanangan"]},
    { municipality: "Loboc", barangays: ["Agape", "Alegria", "Bagumbayan", "Bahian", "Bonbon Lower", "Bonbon Upper", "Buenavista", "Bugho", "Cabadiangan", "Calunasan Norte", "Calunasan Sur", "Camayaan", "Cambance", "Candabong", "Candasag", "Canlasid", "Gon-ob", "Gotozon", "Jimilian", "Oy", "Poblacion Ondol", "Poblacion Sawang", "Quinoguitan", "Taytay", "Tigbao", "Ugpong", "Valladolid", "Villaflor"]},
    { municipality: "Loon", barangays: ["Agsoso", "Badbad Occidental", "Badbad Oriental", "Bagacay Katipunan", "Bagacay Kawayan", "Bagacay Saong", "Bahi", "Basac", "Basdacu", "Basdio", "Biasong", "Bongco", "Bugho", "Cabacongan", "Cabadug", "Cabug", "Calayugan Norte", "Calayugan Sur", "Cambaquiz", "Campatud", "Candaigan", "Canhangdon Occidental", "Canhangdon Oriental", "Canigaan", "Canmaag", "Canmanoc", "Cansuagwit", "Cansubayon", "Cantam-is Bago", "Cantam-is Baslay", "Cantaongon", "Cantumocad", "Catagbacan Handig", "Catagbacan Norte", "Catagbacan Sur", "Cogon Norte (Pob.)", "Cogon Sur", "Cuasi", "Genomoan", "Lintuan", "Looc", "Mocpoc Norte", "Mocpoc Sur", "Moto Norte (Pob.)", "Moto Sur (Pob.)", "Nagtuang", "Napo (Pob.)", "Nueva Vida", "Panangquilon", "Pantudlan", "Pig-ot", "Pondol", "Quinobcoban", "Sondol", "Song-on", "Talisay", "Tan-awan", "Tangnan", "Taytay", "Ticugan", "Tiwi", "Tontonan", "Tubodacu", "Tubodio", "Tubuan", "Ubayon", "Ubojan"]},
    { municipality: "Mabini", barangays: ["Abaca", "Abad Santos", "Aguipo", "Baybayon", "Bulawan", "Cabidian", "Cawayanan", "Concepcion (Banlas)", "Del Mar", "Lungsoda-an", "Marcelo", "Minol", "Paraiso", "Poblacion I", "Poblacion II", "San Isidro", "San Jose", "San Rafael", "San Roque (Cabulao)", "Tambo", "Tangkigan", "Valaga"]},
    { municipality: "Maribojoc", barangays: ["Agahay", "Aliguay", "Anislag", "Bayacabac", "Bood", "Busao", "Cabawan", "Candavid", "Dipatlong", "Guiwanon", "Jandig", "Lagtangon", "Lincod", "Pagnitoan", "Poblacion", "Punsod", "Punta Cruz", "San Isidro", "San Roque (Aghao)", "San Vicente", "Tinibgan", "Toril"]},
    { municipality: "Panglao", barangays: ["Bil-isan", "Bolod", "Danao", "Doljo", "Libaong", "Looc", "Lourdes", "Poblacion", "Tangnan", "Tawala"]},
    { municipality: "Pilar", barangays:  ["Biking", "Bingag", "Catarman", "Dao", "Mariveles", "Mayacabac", "Poblacion", "San Isidro (Canlongon)", "Songculan", "Tabalong", "Tinago", "Totolan"]},
    { municipality: "Pres. Carlos P. Garcia", barangays:["Aguining", "Basiao", "Baud", "Bayog", "Bogo", "Bonbonon", "Butan", "Campamanog", "Canmangao", "Gaus", "Kabangkalan", "Lapinig", "Lipata", "Poblacion", "Popoo", "Saguise", "San Jose (Tawid)", "San Vicente", "Santo Rosario", "Tilmobo", "Tugas", "Tugnao", "Villa Milagrosa"]},
    { municipality: "Sagbayan", barangays: ["Calangahan", "Canmano", "Canmaya Centro", "Canmaya Diot", "Dagnawan", "Kabasacan", "Kagawasan", "Katipunan", "Langtad", "Libertad Norte", "Libertad Sur", "Mantalongon", "Poblacion", "Sagbayan Sur", "San Agustin", "San Antonio", "San Isidro", "San Ramon", "San Roque", "San Vicente Norte", "San Vicente Sur", "Santa Catalina", "Santa Cruz", "Ubojan"]},
    { municipality: "San Isidro", barangays: ["Abehilan", "Baryong Daan", "Baunos", "Cabanugan", "Caimbang", "Cambansag", "Candungao", "Cansague Norte", "Cansague Sur", "Causwagan Sur", "Masonoy", "Poblacion"]},
    { municipality: "San Miguel", barangays: ["Bayongan", "Bugang", "Cabangahan", "Caluasan", "Camanaga", "Cambangay Norte", "Capayas", "Corazon", "Garcia", "Hagbuyo", "Kagawasan", "Mahayag", "Poblacion", "San Isidro", "San Jose", "San Vicente", "Santo Niño", "Tomoc"]},
    { municipality: "Sevilla", barangays: ["Bayawahan", "Cabancalan", "Calinga-an", "Calinginan Norte", "Calinginan Sur", "Cambagui", "Ewon", "Guinob-an", "Lagtangan", "Licolico", "Lobgob", "Magsaysay", "Poblacion"]},
    { municipality: "Sierra Bullones", barangays: ["Abachanan", "Anibongan", "Bugsoc", "Cahayag", "Canlangit", "Canta-ub", "Casilay", "Danicop", "Dusita", "La Union", "Lataban", "Magsaysay", "Nan-od", "Matin-ao", "Poblacion", "Salvador", "San Agustin", "San Isidro", "San Jose", "San Juan", "Santa Cruz", "Villa Garcia"]},
    { municipality: "Sikatuna", barangays: ["Abucay Norte", "Abucay Sur", "Badiang", "Bahaybahay", "Cambuac Norte", "Cambuac Sur", "Canagong", "Libjo", "Poblacion I", "Poblacion II"]},
    { municipality: "Tagbilaran City", barangays: ["Bool", "Booy", "Cabawan", "Cogon", "Dampas", "Dao", "Manga", "Mansasa", "Poblacion I", "Poblacion II", "Poblacion III", "San Isidro", "Taloto", "Tiptip", "Ubujan"]},
    { municipality: "Talibon", barangays: ["Bagacay", "Balintawak", "Burgos", "Busalian", "Calituban", "Cataban", "Guindacpan", "Magsaysay", "Mahanay", "Nocnocan", "Poblacion", "Rizal", "Sag", "San Agustin", "San Carlos", "San Francisco", "San Isidro", "San Jose", "San Pedro", "San Roque", "Santo Niño", "Sikatuna", "Suba", "Tanghaligue", "Zamora"]},
    { municipality: "Trinidad", barangays: ["Banlasan", "Bongbong", "Catoogan", "Guinobatan", "Hinlayagan Ilaud","Hinlayagan Ilaya", "Kauswagan", "Kinan-oan", "La Union", "La Victoria","Mabuhay Cabigohan", "Mahagbu", "Manuel M. Roxas", "Poblacion", "San Isidro","San Vicente", "Santo Tomas", "Soom", "Tagum Norte", "Tagum Sur"]},
    { municipality: "Tubigon", barangays: ["Bagongbanwa", "Banlasan", "Batasan (Batasan Island)", "Bilangbilangan (Bilangbilangan Island)","Bosongon", "Buenos Aires", "Bunacan", "Cabulihan", "Cahayag", "Cawayanan","Centro (Pob.)", "Genonocan", "Guiwanon", "Ilihan Norte", "Ilihan Sur", "Libertad","Macaas", "Matabao", "Mocaboc Island", "Panadtaran", "Panaytayon","Pandan","Pangapasan (Pangapasan Island)", "Pinayagan Norte", "Pinayagan Sur", "Pooc Occidental (Pob.)","Pooc Oriental (Pob.)", "Potohan", "Talenceras", "Tan-awan", "Tinangnan", "Ubay Island", "Ubojan", "Villanueva"]},
    { municipality: "Ubay", barangays:["Achila", "Bay-ang", "Benliw", "Biabas", "Bongbong", "Bood", "Buenavista", "Bulilis", "Cagting", "Calanggaman", "California", "Camali-an", "Camambugan", "Casate", "Cuya", "Fatima", "Gabi", "Governor Boyles", "Guintabo-an", "Hambabauran", "Humayhumay", "Ilihan", "Imelda", "Juagdan", "Katarungan", "Lomangog", "Los Angeles", "Pag-asa", "Pangpang", "Poblacion", "San Francisco", "San Isidro", "San Pascual", "San Vicente", "Sentinila", "Sinandigan", "Tapal", "Tapon", "Tintinan", "Tipolo", "Tubog", "Tuboran", "Union", "Villa Teresita"]},
    { municipality: "Valencia", barangays: ["Adlawan", "Anas", "Anonang", "Anoyon", "Balingasao", "Banderahan (Upper Ginopolan)", "Botong", "Buyog", "Canduao Occidental", "Canduao Oriental", "Canlusong", "Canmanico", "Cansibao", "Catug-a", "Cutcutan", "Danao", "Genoveva", "Ginopolan (Ginopolan Proper)", "La Victoria", "Lantang", "Limocon", "Loctob", "Magsaysay", "Marawis", "Maubo", "Nailo", "Omjon", "Pangi-an", "Poblacion Occidental", "Poblacion Oriental", "Simang", "Taug", "Tausion", "Taytay", "Ticum"]},
  ];

  const handleSave = async () => {
    if (!user || !user.id) {
      setError("User not authenticated");
      return;
    }

    const newAddress = {
      user_id: user.id,
      name,
      phone_number: phone,
      municipality: selectedMunicipality,
      barangay: selectedBarangay,
      home_address: homeAddress,
    };

    const response = await addAddress(newAddress);
    if (response) {
      setShowSuccessModal(true);
    }
  };

  const handleMunicipalityChange = (e) => {
    const selected = e.target.value;
    setSelectedMunicipality(selected);
    const data = boholData.find((item) => item.municipality === selected);
    setBarangays(data ? data.barangays : []);
    setSelectedBarangay("");
  };

  const handleCloseSuccessModal = () => {
    setShowSuccessModal(false);
    onClose();
  };

  return (
    <>
      <Container>
        <Header>
          <Title>Add New Address</Title>
          <CloseButton onClick={onClose}>×</CloseButton>
        </Header>
        {(error || apiError) && <ErrorMessage>{error || apiError}</ErrorMessage>}
        <FormContent>
          <Section>
            <SectionTitle>Contact information</SectionTitle>
            <InputWrapper>
              <label>Enter name</label>
              <input type="text" placeholder="Enter name" value={name} onChange={(e) => setName(e.target.value)} />
            </InputWrapper>
            <InputWrapper>
              <label>Enter valid phone number</label>
              <input type="text" placeholder="Enter phone number" value={phone} onChange={(e) => setPhone(e.target.value)} />
            </InputWrapper>
          </Section>
          <Section>
            <SectionTitle>Address information</SectionTitle>
            <InputWrapper>
              <label>Municipality</label>
              <select value={selectedMunicipality} onChange={handleMunicipalityChange}>
                <option value="">-- Select Municipality --</option>
                {boholData.map((data, index) => (
                  <option key={index} value={data.municipality}>{data.municipality}</option>
                ))}
              </select>
            </InputWrapper>
            {barangays.length > 0 && (
              <InputWrapper>
                <label>Barangay</label>
                <select value={selectedBarangay} onChange={(e) => setSelectedBarangay(e.target.value)}>
                  <option value="">-- Select Barangay --</option>
                  {barangays.map((barangay, index) => (
                    <option key={index} value={barangay}>{barangay}</option>
                  ))}
                </select>
              </InputWrapper>
            )}
            <InputWrapper>
              <label>Enter home address</label>
              <input type="text" placeholder="Enter home address" value={homeAddress} onChange={(e) => setHomeAddress(e.target.value)} />
            </InputWrapper>
          </Section>
          <Form>
            <SubmitButton onClick={handleSave} disabled={loading}>
              {loading ? "Saving..." : "Save Address"}
            </SubmitButton>
          </Form>
        </FormContent>
      </Container>

      {showSuccessModal && (
        <ModalBackdrop onClick={handleCloseSuccessModal}>
          <ModalContent onClick={(e) => e.stopPropagation()}>
            <SuccessText>Address added successfully!</SuccessText>
            <SuccessButton onClick={handleCloseSuccessModal}>OK</SuccessButton>
          </ModalContent>
        </ModalBackdrop>
      )}
    </>
  );
};

export default NewAddress;

// Styled Components
const Container = styled.div`
  max-width: 700px;
  padding: 20px;
  background: #eaf4e1;
  margin: 0 auto;
  position: relative; /* Ensure positioning context for the absolute CloseButton */
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2px 0;
  width: 100%;
  position: sticky;
  top: 2;
  z-index: 10;
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  flex: 1;
  color: green;
`;

const CloseButton = styled.button`
  position: absolute;
  top: -20px;
  right: -20px;
  font-size: 25px;
  font-weight: bold;
  color: green;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  width: 30px; /* Fixed width for circular shape */
  height: 30px; /* Fixed height for circular shape */
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%; /* Circular shape */
  transition: background-color 0.3s ease, color 0.3s ease; /* Smooth transition for hover effect */

  &:hover {
    color: red;
    background-color: rgba(128, 128, 128, 0.5); /* Gray overlay on hover */
  }
`;

const FormContent = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

const Section = styled.div`
  margin-bottom: 20px;
  border-top: 2px solid #ddd;
  padding-top: 15px;
`;

const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
  color: green;
`;

const InputWrapper = styled.div`
  margin-bottom: 15px;
  width: 100%;

  label {
    display: block;
    font-size: 14px;
    color: green;
    margin-bottom: 5px;
  }

  input,
  select {
    width: 100%;
    padding: 7px;
    font-size: 14px;
    border: 2px solid green;
    border-radius: 5px;
    box-sizing: border-box;
  }
`;

const ErrorMessage = styled.p`
  color: red;
  text-align: center;
`;

const Form = styled.div`
  display: flex;
  justify-content: center;
`;

const SubmitButton = styled.button`
  font-size: 16px;
  color: white;
  background-color: green;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: darkgreen;
  }

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }
`;

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: rgb(249, 249, 249);
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  width: 300px;
`;

const SuccessText = styled.p`
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
`;

const SuccessButton = styled.button`
  font-size: 16px;
  color: white;
  background-color: green;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: darkgreen;
  }
`;